import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/ADMINSETTING') => `${reducer}/${actionType}`;

export const getList = () => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const $list = res.info || [];

			const itemsStatus = {
				ShowTopSlider: true,
				ShowCurrencyPanel: true,
				ShowTranslateCurrency: true,
				ShowGlobalClock: true,
				ShowNews: true,
				ShowArchiveCurrency: true,
				ShowForms: true,
				ShowTurn: true,
				ShowLinks: true,
				ShowEvents: true,
				REMAINING_SMS: true,
				demo_mode: true,
			};

			const requiredList = $list.reduce(
				(prev, current) => (itemsStatus[current.SYMBOL] ? [...prev, current] : prev),
				[],
			);

			let turnRule;
			let turnDocument;

			$list.map((item) => {
				if (item.SYMBOL === 'Turn_Rule') turnRule = item.VALUE;
				else if (item.SYMBOL === 'Turn_Document') turnDocument = item.VALUE;
			});

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminSetting,
					$list,
					filteredConfigList: requiredList,
					turnRule: turnRule,
					turnDoc: turnDocument,
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminSetting,
					$list: [],
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminSetting,
					_status: status,
				},
			});
		};

		api.$config_fetch_All({ onOK, onFail, onStatus }, {});
	};
};

export const updateSetting = (symbolSelected = '', resultValue = '', type = 'isBtn') => {
	return async (dispatch, getState) => {
		const { turn } = getState().page.adminSetting;
		const { turnSelectedSymbol } = turn;

		const onOK = async (res) => {
			await dispatch(getList());
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminSetting,

					turn: {
						...getState().page.adminSetting.turn,
						turnSelectedSymbol: '',
						turnRuleValue: '',
						turnDocumentValue: '',
					},
				},
			});
		};

		let value;
		let symbol;

		value = type === 'isText' ? resultValue : resultValue === 'Y' ? 'N' : 'Y';
		symbol = type === 'isText' ? turnSelectedSymbol : symbolSelected;

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminSetting,
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminSetting,
					turn: {
						...getState().page.adminSetting.turn,
						...(type === 'isText' && { _turnStatus: status }),
					},
				},
			});
		};

		api.$config_edit_Symbol(
			{ onOK, onFail, onStatus, ...(type === 'isText' && { showOkMessage: true }) },
			{ symbol, value },
		);
	};
};
